import { IBeachType } from '.';

const dataAttributesBeachType: IBeachType[] = [
    {
        id: 1,
        key: 'sandBeach',
        keyMerged: 'sandBeach',
        name: 'Песчаный',
        nameLayer: 'тип пляжа_Песчаный',
    },
    {
        id: 2,
        key: 'pebbleBeach',
        keyMerged: 'pebbleBeach',
        name: 'Галечный',
        nameLayer: 'тип пляжа_Галечный',
    },
    {
        id: 3,
        key: 'sandPebbleBeach',
        keyMerged: 'sandPebbleBeach',
        name: 'Песчано-галечный',
    },
];

export default dataAttributesBeachType;